import { Component, OnInit, Input, Inject } from '@angular/core';
import { captureRejectionSymbol } from 'events';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { DOCUMENT } from '@angular/common';

import { MarketService } from 'src/app/shared/services/market.service';
import { PropertyValuationService } from 'src/app/shared/services/property-valuation.service';
import { SponsorDataService } from '../../services/sponsor_data.service';

@Component({
  selector: 'app-edit-sponsorship-application',
  templateUrl: './edit-sponsorship-application.component.html',
  styleUrls: ['./edit-sponsorship-application.component.css']
})
export class EditSponsorshipApplicationComponent implements OnInit {

  @Input() applicationInfo: any;
  @Input() visible: boolean = false;

  rejectForm: FormGroup;

  _application_details: any;
  application_approved: boolean;
  isLoading: boolean;

  imageBaseUrl = "https://cherymaupps3gradebookexample.s3.amazonaws.com/"
  application_rejected: boolean;
  showTextarea: boolean;
  showButtons: boolean;
  valuation: any;
  proposalLink: any;
  private _application_reject_details: any;

  constructor(@Inject(DOCUMENT) private document: any, private marketService: MarketService, private spData: SponsorDataService, private valuationService: PropertyValuationService,
    private fb: FormBuilder) {
    this.rejectForm = this.fb.group({
      description: ['', [Validators.required]],
    });
  }

  ngOnInit(): void {
    this.showButtons = true;
    this.valuation = history.state;
  }

  onApprovedApplication(applicationBody: any) {
    this.isLoading = true;

    this._application_details = applicationBody;
    const _object = {
      owner_id: this._application_details.id,
      meta: this._application_details.meta,
      status: 'APPROVED'
    }
    console.log('Application approved ==> ', _object);
    this.marketService.updateSponsorshipApplicationStatus(_object)
      .subscribe((data) => {
        this.isLoading = false;
        console.log('DATA => ', data)
        if (data.Attributes.status === 'APPROVED') {
          this.application_approved = true;
        }
        else {
          console.log('Failure');
        }
      })
  }

  onRejectApplication(applicationBody: any) {
    this.isLoading = true;
    console.log('Application Rejected');

    this._application_details = applicationBody;
    const _object = {
      owner_id: this._application_details.id,
      meta: this._application_details.meta,
      status: 'REJECTED'
    }
    console.log('Application approved ==> ', _object);
    this.marketService.updateSponsorshipApplicationStatus(_object)
      .subscribe((data) => {
        this.isLoading = false;
        console.log('DATA => ', data)
        console.log("APP status ==> ", data.Attributes.status);
        // this.onRejectApplication(applicationBody); 
        if (data.Attributes.status === 'REJECTED') {
          console.log('SUCCESS');
          // this.onRejectApplication(applicationBody)
          this.application_rejected = true;
          console.log('Application being Rejected ...');

          this._application_reject_details = applicationBody;
          const _reject_object = {
            owner_id: this._application_reject_details.id,
            meta: this._application_reject_details.meta,
            // rejection_reason: document.getElementById('reject_cause').innerHTML
            rejection_reason: this.document.getElementById('reject_cause').value
          };

          console.log('Application rejected for reasons ==> ', _reject_object);

          this.marketService.rejectApplicationDescription(_reject_object)
            .subscribe((data) => {
              this.isLoading = false;
              console.log('Rejection DATA => ', data)
            })
        }
        else if (data.Attributes.status === 'APPROVED') {
          console.log('Application Approved !!!');
        }
        else {
          console.log('UnSUCCESSFUL')
        }
      })
  }

  onRejectionReason(applicationBody: any) {
    this.isLoading = true;
    console.log('Application being Rejected ...');

    this._application_details = applicationBody;
    const _object = {
      owner_id: this._application_details.id,
      meta: this._application_details.meta,
      // rejection_reason: document.getElementById('reject_cause').innerHTML 
      rejection_reason: 'Not enough Documents submitted'
    };

    console.log('Application rejected for reasons ==> ', _object);
    this.marketService.rejectApplicationDescription(_object)
      .subscribe((data) => {
        this.isLoading = false;
        console.log('Rejection DATA => ', data)
      })
  }

  onViewProposal() {

    console.log('View called !!!')

    var payload = {
      bucket: "cherymaupps3gradebookexample",
      key: document.getElementById('proposalLink').innerHTML
    }



    this.valuationService.getProposalDocument(payload).subscribe((data) => {
      console.log('payload ==> ', payload);

      console.log("Signed Url", data);
      window.open(data.signedurl, "_blank");

    }, (error) => {
      console.log("Error getting signed Url", error);
    });

    console.log("S3 signed url payload", payload);
  }

  onShowTextarea() {
    this.showTextarea = true;
    this.showButtons = false;
  }

  close() {
    // this.spData.sendData(false);
    console.log('Close() called')
    this.visible = false;
  }

}
